import { Link } from "react-router-dom";
import { CiEdit } from "react-icons/ci";
import styles from "./approved-bank-account.module.scss";
import AfterOnboardAPI from "../../../../services/AfterOnboardAPI";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { addAccountId } from "../../../../redux/slices/userSlice";
import Drawer from "@mui/material/Drawer";
import CustomButton from "../../../../components/Button/CustomButton";
import { useTheme } from "@mui/material/styles";
import { 
  clevertap_bank_confirmation_pl_screen,
  clevertap_bank_confirmation_pl_screen_click,
} from "../../../../lib/clevertap-events";

export default function ApprovedBankAccount({ setBankData }) {
  const [data, setData] = useState([]);
  const [show, setShow] = useState({ bottom: false });
  const [activeBank, setActiveBank] = useState(null);

  const dispatch = useDispatch();

  const theme = useTheme();

  useEffect(() => {
    const fetchAPI = async () => {
      const { getApprovedBankAccountAPI } = new AfterOnboardAPI();
      const res = await getApprovedBankAccountAPI();
      if (res && res.statusCode === 200) {
        setData(res.data);

        let bank = res?.data?.filter((bank) => bank.isActive)[0];

        if (res?.data?.length > 0 && !bank) {
          bank = res?.data[0];
        }

        setActiveBank(bank);
        setBankData(bank);
        dispatch(addAccountId(bank?.accountID));
      }
    };

    fetchAPI();
  }, []);

  useEffect(() => {
    if(show.bottom) {
      clevertap_bank_confirmation_pl_screen();
    }
  }, [show.bottom])

  if (data.length === 0) return null;
  return (
    <>
      <div className={styles.approvedBankWrapper}>
        <div className={styles.header}>
          <h5>Bank Account</h5>
          {data.length > 0 ? (
            <span className={styles.selectBanks} onClick={() => setShow({ ...show, bottom: true })}>
              Select Bank
            </span>
          ) : (
            <Link to="/bank-details" state={{ shouldBankFetch: false }}>
              + Add Account
            </Link>
          )}

          {/* {data.length > 1 && (
            <span className={styles.selectBanks} onClick={() => setShow({ ...show, bottom: true })}>
              Select Bank
            </span>
          )} */}
        </div>

        {activeBank && (
          <div className={styles.bankCards}>
            <div className={styles.bankBlocks}>
              <div className={styles.bankLogo}>
                <img src={activeBank.bankIcon} alt="" />
              </div>
              <div className={styles.bankName}>
                <p>{activeBank.bank}</p>
                <span>Account: {activeBank.accountNo}</span>
                <span>IFSC: {activeBank.bankIfsc}</span>
              </div>
            </div>
            <div style={{ display: "none" }}>
              <Link to="/bank-details">
                <CiEdit size={22} />
              </Link>
            </div>

            {activeBank.status === "Verified" && (
              <div className={styles.verified}>
                <span>Verified</span>
              </div>
            )}
          </div>
        )}
      </div>

      <div className={styles.allBankslists}>
        <Drawer
          anchor="bottom"
          open={show["bottom"]}
          onClose={() => setShow({ ...show, bottom: false })}
          sx={{
            "& .MuiDrawer-paper": {
              maxWidth: 480,
              width: "100%",
              margin: "0 auto",
              left: "0",
              [theme.breakpoints.up("sm")]: {
                left: 0,
              },
              display: "flex",
              flexDirection: "column",
              maxHeight: "85vh",
            },
          }}
        >
          <div className={styles.bankListInner}>
            <div className={styles.bankInnerTitle}>
              <h4>Select Bank</h4>
              <Link to="/bank-details" state={{ shouldBankFetch: false }}>
                + Add Account
              </Link>
            </div>

            <div className={styles.bankListScroll}>
              {data.map((item, index) => (
                <div
                  className={`${styles.bankCards} ${item?.accountID === activeBank?.accountID ? styles.active : ""}`}
                  key={index}
                  onClick={() => {
                    setActiveBank(item);
                    setBankData(item);
                    setShow({ ...show, bottom: false });
                    clevertap_bank_confirmation_pl_screen_click({
                      bank:item?.bank
                    });
                  }}
                >
                  <div className={styles.bankBlocks}>
                    <div className={styles.bankLogo}>
                      <img src={item.bankIcon} alt="" />
                    </div>
                    <div className={styles.bankName}>
                      <p>{item.bank}</p>
                      <span>Account: {item.accountNo}</span>
                      <span>IFSC: {item.bankIfsc}</span>
                    </div>
                  </div>

                  {item.status === "Verified" && (
                    <div className={styles.verified}>
                      <span>Verified</span>
                    </div>
                  )}
                </div>
              ))}
            </div>

            {/* <div>
              <CustomButton
                text="Add Bank"
                onClick={() => {
                  setShow({ ...show, bottom: false });
                }}
              />
            </div> */}
          </div>
        </Drawer>
      </div>
    </>
  );
}
